
import { StateMachine } from "slotworks/state-machine/state-machine";
import State from "slotworks/state-machine/states/state";
import Timer from "slotworks/utils/timer";

export default class DelayState extends State {

    private wait: number = 0;

    constructor(stateMachine: StateMachine, wait: number) {
        super(stateMachine);
        this.wait = wait;
    }

    public onEnter() {
        if (this.wait > 0) {
            Timer.setTimeout(() => this.complete(), this.wait);
        } else {
            this.complete();
        }
    }
}
